import _kebabCase from 'lodash/kebabCase';
import { Google, Pixall } from '../analytics/index.js';
import { getInventoryOwnerById, isVDP } from '../utilities/index.js';
import { valueEventCode } from '../constants/index.js';
import { inventoryTransformer as pixallInventoryTransformer } from '../transformers/pixall/index.js';
import { inventoryTransformer as googleInventoryTransformer } from '../transformers/google/index.js';
export async function creditAppGetPreQualifiedClick(_ref, option) {
  let {
    data = {},
    event,
    state,
    dataLayer
  } = _ref;
  if (option === void 0) {
    option = {};
  }
  const {
    listingId,
    partner,
    section
  } = data;
  const inventory = getInventoryOwnerById(state, listingId);
  const isAccelerate = inventory?.paymentServices?.digitalRetailingType === 'accelerate';
  const partnerCopy = partner?.toLowerCase();
  const linkCopy = event?.target?.innerText || event?.target?.textContent || '';
  const isPriceCardCTA = linkCopy === 'Apply Now';
  const partnerPrefix = isAccelerate || partnerCopy === 'saca' ? 'caca-' : '';
  const cmp = isPriceCardCTA ? linkCopy : 'get_prequal';
  let eventResult = `text-link::${partnerPrefix}${partnerCopy}::${_kebabCase(linkCopy)}`;
  let eventElement = 'nds';
  let label;
  let feature = 'caca';
  let leadType;
  let calculatorType;
  let cdl;
  let gaVehicle;
  switch (partnerCopy) {
    case 'saca':
      label = `text-link::${partnerCopy}::${_kebabCase(linkCopy)}::${section}`;
      leadType = 'credit';
      calculatorType = 'payment';
      cdl = {
        eventProperties: {
          event: {
            valueEventCode: valueEventCode.CREDIT_APP
          }
        }
      };
      gaVehicle = {
        cj_ga_event_value_code: valueEventCode.CREDIT_APP
      };
      break;
    case 'amd':
      label = `text-link::${partnerCopy}::${_kebabCase(linkCopy)}::${section}`;
      eventElement = 'accelerate';
      feature = 'dr3';
      leadType = 'credit';
      calculatorType = 'payment';
      cdl = {
        eventProperties: {
          event: {
            valueEventCode: valueEventCode.CREDIT_APP
          }
        }
      };
      gaVehicle = {
        cj_ga_event_value_code: valueEventCode.CREDIT_APP
      };
      break;
    case 'psx':
      label = `${eventResult}::${section}`;
      feature = 'psx';
      calculatorType = 'payment';
      cdl = {
        eventProperties: {
          vehicle: pixallInventoryTransformer.getVehicleCommonDataLayer(inventory)
        }
      };
      break;
    default:
      label = `get_prequal - ${partnerCopy} - ${section}`;
  }
  if (isPriceCardCTA) {
    label = `${linkCopy} - ${partnerCopy}`;
    eventElement = 'accelerate';
    eventResult += '::payment-card';
  } else {
    eventResult += `::${section}`;
  }
  Pixall.sendClickEvent({
    eventSource: 'dealership',
    leadType,
    feature,
    label,
    inventory,
    calculatorType,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    },
    cdl
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement,
    eventResult,
    eventData: {
      vehicle: googleInventoryTransformer(inventory, {
        target: 'vehicle',
        dataLayer
      })
    },
    ...(gaVehicle && {
      vehicle: {
        ...gaVehicle
      }
    })
  }, option);
  return {
    cmp,
    label
  };
}
export async function standaloneCreditAppClick(_ref2, option) {
  let {
    data = {},
    state,
    dataLayer
  } = _ref2;
  if (option === void 0) {
    option = {};
  }
  const {
    listingId,
    eventData = {}
  } = data;
  const inventory = getInventoryOwnerById(state, listingId);
  const eventMap = {
    DR_STANDALONE_CREDIT_APP_STARTED: {
      applicationType: 'credit',
      eventSource: 'application',
      eventType: 'step',
      label: 'stndaln_crd_app_str'
    },
    DR_STANDALONE_CREDIT_APP_PERSONAL_CTA_CLICKED: {
      applicationType: 'credit',
      eventSource: 'application',
      eventType: 'step',
      label: 'stndaln_crd_app_step_pi'
    },
    DR_STANDALONE_CREDIT_APP_HOUSING_CTA_CLICKED: {
      applicationType: 'credit',
      eventSource: 'application',
      eventType: 'step',
      label: 'stndaln_crd_app_step_housing'
    },
    DR_STANDALONE_CREDIT_APP_EMPLOYMENT_CTA_CLICKED: {
      applicationType: 'credit',
      eventSource: 'application',
      eventType: 'step',
      label: 'stndaln_crd_app_incm'
    },
    DR_STANDALONE_CREDIT_APP_SUBMIT_CTA_CLICKED: {
      applicationType: 'credit',
      eventSource: 'application',
      eventType: 'step',
      label: 'stndaln_crd_app_submit_btn'
    },
    DR_STANDALONE_CREDIT_APP_SUBMITTED: {
      eventSource: 'lead',
      eventType: 'submit',
      label: 'stndaln_crd_app_submit',
      leadContext: 'finance-application',
      leadType: 'form'
    }
  };
  const eventName = eventData?.message?.eventName;
  if (eventMap[eventName]) {
    Pixall.sendClickEvent({
      feature: 'caca',
      pageId: 'standaloneCreditApp',
      pageType: 'creditapp',
      ...eventMap[eventName],
      inventory
    }, dataLayer, option);
  }
  if (eventName === 'DR_STANDALONE_CREDIT_APP_SUCCESS_DISPLAYED') {
    Google.sendClickEvent({
      eventElement: 'standalone',
      eventAction: 'submit',
      eventResult: 'text-link::caca-saca',
      eventData: {
        vehicle: googleInventoryTransformer(inventory, {
          target: 'vehicle',
          dataLayer
        })
      }
    }, option);
  }
  return {};
}
export default {
  creditAppGetPreQualifiedClick,
  standaloneCreditAppClick
};